import React from "react";
import { NavLink, Outlet, Navigate } from "react-router-dom";
import { BookOpen, GraduationCap, Download, Megaphone, Users, ArrowLeft, Shield, Sparkles, Send, LifeBuoy, Wallet } from "lucide-react";
import { useAuth } from "@/lib/auth";

const ADMIN_NAV = [
  { to: "/admin/knowledge", label: "Knowledge Management", icon: BookOpen },
  { to: "/admin/academy", label: "Academy Management", icon: GraduationCap },
  { to: "/admin/downloads", label: "Downloads Management", icon: Download },
  { to: "/admin/announcements", label: "Announcements", icon: Megaphone },
  { to: "/admin/telegram", label: "Telegram Channels", icon: Send },
  { to: "/admin/ai-escalations", label: "AI Escalations", icon: LifeBuoy },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/payments", label: "Payments", icon: Wallet },
  { to: "/admin/ai-review", label: "AI Review", icon: Sparkles },
];

export default function AdminLayout() {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-10 animate-fade-in">
      <aside className="lg:sticky lg:top-24 lg:self-start">
        <div className="mb-6">
          <NavLink
            to="/"
            className="inline-flex items-center gap-2 text-xs text-zinc-500 hover:text-white"
            style={{ transitionProperty: "color", transitionDuration: "160ms" }}
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Back to app
          </NavLink>
        </div>
        <div className="flex items-center gap-2 mb-6">
          <Shield className="w-4 h-4 text-gold" strokeWidth={1.75} />
          <span className="text-[10px] uppercase tracking-[0.3em] text-gold font-semibold">Admin Panel</span>
        </div>
        <nav className="space-y-0.5">
          {ADMIN_NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm ${
                  isActive
                    ? "bg-white/5 text-gold border-l-2 border-gold pl-[10px]"
                    : "text-zinc-400 hover:text-white hover:bg-white/5"
                }`
              }
              style={{ transitionProperty: "color, background-color", transitionDuration: "160ms" }}
            >
              <item.icon className="w-4 h-4" strokeWidth={1.75} />
              <span className="truncate">{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
